import Marquee from "react-fast-marquee";

const WORDS = ["Technology", "Digital Media", "Hospitality", "AI Automation", "Product"];

export default function BrandMarquee() {
  return (
    <section
      data-testid="brand-marquee"
      className="border-y border-hairline bg-surface/40 py-8"
      aria-hidden="true"
    >
      <Marquee speed={34} gradient gradientColor="#050914" gradientWidth={120}>
        {WORDS.concat(WORDS).map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="px-10 font-display text-2xl font-medium uppercase tracking-[0.15em] text-fog sm:text-3xl">
              {w}
            </span>
            <span className="h-1.5 w-1.5 rotate-45 bg-steel-light/70" />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
